import { BaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/BaseApiResponseModel";
import { ListBaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/ListBaseApiResponseModel";
import { CdnConfigInjection } from "features/cdnConfiguration/di/CdnConfigInjection";
import { injectable } from "tsyringe";
import { CdnConfigurationFormRequestEntity } from "../entities/CdnConfigurationFormRequestEntity";
import { CdnConfigurationListRequestEntity } from "../entities/CdnConfigurationListRequestEntity";
import { CdnConfigurationResponseEntity } from "../entities/CdnConfigurationResponseEntity";
import { ICdnConfigurationRepository } from "../repositories/ICdnConfigurationRepository";

@injectable()
export class CdnConfigurationUseCase {
  private cdnConfigRepo: ICdnConfigurationRepository;

  constructor() {
    this.cdnConfigRepo = CdnConfigInjection.getRepo();
  }

  async getCdnConfigurationList(
    params: CdnConfigurationListRequestEntity,
  ): Promise<ListBaseApiResponseModel<CdnConfigurationResponseEntity>> {
    return await this.cdnConfigRepo.getList(params);
  }

  async uploadCdnConfiguration(
    body: CdnConfigurationFormRequestEntity,
  ): Promise<BaseApiResponseModel<CdnConfigurationResponseEntity>> {
    return await this.cdnConfigRepo.uploadFile(body);
  }

  async deleteCdnConfiguration(params: {
    code: string;
  }): Promise<BaseApiResponseModel<CdnConfigurationResponseEntity>> {
    return await this.cdnConfigRepo.deleteFile(params);
  }
}
